const CLOSE_BUTTON_SELECTOR = "[data-menu-drawer-close]";

type DrawerWithClose = HTMLElement & {
  closeMenuDrawer: (event: Event, elementToFocus: HTMLElement) => void;
};

const isDrawerWithClose = (
  element: Element | null,
): element is DrawerWithClose => {
  if (!(element instanceof HTMLElement)) return false;
  if (!("closeMenuDrawer" in element)) return false;

  return typeof element.closeMenuDrawer === "function";
};

const closeMenuDrawer = (button: HTMLButtonElement, event: Event) => {
  const drawer = button.closest("header-drawer");
  if (!isDrawerWithClose(drawer)) return;

  const summary = drawer.querySelector("summary");
  if (!(summary instanceof HTMLElement)) return;

  summary.setAttribute("aria-expanded", "false");
  drawer.closeMenuDrawer(event, summary);
};

export const initMenuDrawerClose = () => {
  document.addEventListener("click", (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const button = target.closest(CLOSE_BUTTON_SELECTOR);
    if (!(button instanceof HTMLButtonElement)) return;

    closeMenuDrawer(button, event);
  });
};
